export default {
    form: (vendor_id) => {
      return {
        name: "Krijo Departament",
        submit: {
          label: "Krijo",
          action: "submitDepartment",
        },
        fields: [
          [
            {
              value: "",
              name: "code",
              label: "Kodi",
              type: "text-field",
              style: "flex-grow: 0.3",
              required: true,
              required_text: "Kjo fushe eshte e detyrueshme",
              unique: {
                model: "department",
                field: "code",
                where: [
                  {
                    column: 'vendor_id',
                    condition: '=',
                    value: vendor_id
                  }
                ],
              },
              left_icon: "fa-solid fa-hashtag",
            },
            {
              value: "",
              name: "name",
              label: "Emri",
              type: "text-field",
              style: "flex-grow: 0.6",
              required: true,
              required_text: "Kjo fushe eshte e detyrueshme",
            },
          ],
          {
            value: "",
            name: "printer_ip",
            label: "Printeri",
            type: "text-field",
            style: "flex-grow: 0.4",
            required: true,
            required_text: "Kjo fushe eshte e detyrueshme",
          },
        ],
      };
    },
  };
  
  